const blueLight = '#7AC4FF'
const blue = '#007AFF'
const blueDark = '#0051D4'
const blueMidDark = '#003DA6'
const offWhite = '#FFFFFF'
const veryLightGrey = '#F5F8FD'
const cardGradient = `linear-gradient(180deg, ${offWhite} 0%, ${veryLightGrey} 100%)`

const iconSize = 24
const titleGradient = 'linear-gradient(90deg, rgb(79, 70, 229), rgb(6, 182, 212))'

const ShieldIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" stroke={blue} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s8-4 8-10V5l-8-3-8 3v6c0 6 8 10 8 10z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
)
const DataIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" stroke="none" fill={blue} style={{ flexShrink: 0 }}>
    <path d="M3,1H19A1,1 0 0,1 20,2V6A1,1 0 0,1 19,7H3A1,1 0 0,1 2,6V2A1,1 0 0,1 3,1M3,9H19A1,1 0 0,1 20,10V10.67L17.5,9.56L11,12.44V15H3A1,1 0 0,1 2,14V10A1,1 0 0,1 3,9M3,17H11C11.06,19.25 12,21.4 13.46,23H3A1,1 0 0,1 2,22V18A1,1 0 0,1 3,17M8,5H9V3H8V5M8,13H9V11H8V13M8,21H9V19H8V21M4,3V5H6V3H4M4,11V13H6V11H4M4,19V21H6V19H4M17.5,12L22,14V17C22,19.78 20.08,22.37 17.5,23C14.92,22.37 13,19.78 13,17V14L17.5,12M17.5,13.94L15,15.06V17.72C15,19.26 16.07,20.7 17.5,21.06V13.94Z" />
  </svg>
)
const BuilderIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <rect x="3" y="3" width="7" height="7" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <rect x="14" y="3" width="7" height="7" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <rect x="3" y="14" width="7" height="7" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <rect x="14" y="14" width="7" height="7" stroke={blue} strokeWidth={2} strokeLinecap="round" />
  </svg>
)
const WorkflowIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" stroke="none" fill={blue} style={{ flexShrink: 0 }}>
    <path d="M21 16V13C21 11.89 20.11 11 19 11H13V8H15V2H9V8H11V11H5C3.89 11 3 11.89 3 13V16H1V22H7V16H5V13H11V16H9V22H15V16H13V13H19V16H17V22H23V16H21M11 4H13V6H11V4M5 20H3V18H5V20M13 20H11V18H13V20M21 20H19V18H21V20Z" />
  </svg>
)
const PlugIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" stroke="none" fill={blue} style={{ flexShrink: 0 }}>
    <path d="M16 7V3H14V7H10V3H8V7C7 7 6 8 6 9V14.5L9.5 18V21H14.5V18L18 14.5V9C18 8 17 7 16 7M16 13.67L13.09 16.59L12.67 17H11.33L10.92 16.59L8 13.67V9.09C8 9.06 8.06 9 8.09 9H15.92C15.95 9 16 9.06 16 9.09V13.67Z" />
  </svg>
)
const BugIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <path d="M9 9v-1a3 3 0 0 1 6 0v1" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <rect x="8" y="9" width="8" height="8" rx="4" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <path d="M4 10h2M18 10h2M4 14h2M18 14h2M12 17v2" stroke={blue} strokeWidth={2} strokeLinecap="round" />
  </svg>
)
const CreationIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <path d="M19 1L17.74 3.75L15 5L17.74 6.26L19 9L20.25 6.26L23 5L20.25 3.75Z M9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5Z M19 15L17.74 17.74L15 19L17.74 20.25L19 23L20.25 20.25L23 19L20.25 17.74Z" stroke={blue} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
)
const PuzzleIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" stroke="none" fill={blue} style={{ flexShrink: 0 }}>
    <path d="M3,13.5A0.5,0.5 0 0,0 2.5,14A0.5,0.5 0 0,0 3,14.5A0.5,0.5 0 0,0 3.5,14A0.5,0.5 0 0,0 3,13.5M6,17A1,1 0 0,0 5,18A1,1 0 0,0 6,19A1,1 0 0,0 7,18A1,1 0 0,0 6,17M10,20.5A0.5,0.5 0 0,0 9.5,21A0.5,0.5 0 0,0 10,21.5A0.5,0.5 0 0,0 10.5,21A0.5,0.5 0 0,0 10,20.5M3,9.5A0.5,0.5 0 0,0 2.5,10A0.5,0.5 0 0,0 3,10.5A0.5,0.5 0 0,0 3.5,10A0.5,0.5 0 0,0 3,9.5M6,13A1,1 0 0,0 5,14A1,1 0 0,0 6,15A1,1 0 0,0 7,14A1,1 0 0,0 6,13M21,13.5A0.5,0.5 0 0,0 20.5,14A0.5,0.5 0 0,0 21,14.5A0.5,0.5 0 0,0 21.5,14A0.5,0.5 0 0,0 21,13.5M10,17A1,1 0 0,0 9,18A1,1 0 0,0 10,19A1,1 0 0,0 11,18A1,1 0 0,0 10,17M2.5,5.27L6.28,9.05L6,9A1,1 0 0,0 5,10A1,1 0 0,0 6,11A1,1 0 0,0 7,10C7,9.9 6.97,9.81 6.94,9.72L9.75,12.53C9.04,12.64 8.5,13.26 8.5,14A1.5,1.5 0 0,0 10,15.5C10.74,15.5 11.36,14.96 11.47,14.25L14.28,17.06C14.19,17.03 14.1,17 14,17A1,1 0 0,0 13,18A1,1 0 0,0 14,19A1,1 0 0,0 15,18C15,17.9 14.97,17.81 14.94,17.72L18.72,21.5L20,20.23L3.77,4L2.5,5.27M14,20.5A0.5,0.5 0 0,0 13.5,21A0.5,0.5 0 0,0 14,21.5A0.5,0.5 0 0,0 14.5,21A0.5,0.5 0 0,0 14,20.5M18,7A1,1 0 0,0 19,6A1,1 0 0,0 18,5A1,1 0 0,0 17,6A1,1 0 0,0 18,7M18,11A1,1 0 0,0 19,10A1,1 0 0,0 18,9A1,1 0 0,0 17,10A1,1 0 0,0 18,11M18,15A1,1 0 0,0 19,14A1,1 0 0,0 18,13A1,1 0 0,0 17,14A1,1 0 0,0 18,15M10,7A1,1 0 0,0 11,6A1,1 0 0,0 10,5A1,1 0 0,0 9,6A1,1 0 0,0 10,7M21,10.5A0.5,0.5 0 0,0 21.5,10A0.5,0.5 0 0,0 21,9.5A0.5,0.5 0 0,0 20.5,10A0.5,0.5 0 0,0 21,10.5M10,3.5A0.5,0.5 0 0,0 10.5,3A0.5,0.5 0 0,0 10,2.5A0.5,0.5 0 0,0 9.5,3A0.5,0.5 0 0,0 10,3.5M14,3.5A0.5,0.5 0 0,0 14.5,3A0.5,0.5 0 0,0 14,2.5A0.5,0.5 0 0,0 13.5,3A0.5,0.5 0 0,0 14,3.5M13.8,11.5H14A1.5,1.5 0 0,0 15.5,10A1.5,1.5 0 0,0 14,8.5A1.5,1.5 0 0,0 12.5,10V10.2C12.61,10.87 13.13,11.39 13.8,11.5M14,7A1,1 0 0,0 15,6A1,1 0 0,0 14,5A1,1 0 0,0 13,6A1,1 0 0,0 14,7Z" />
  </svg>
)
const CollaborationIcon = () => (
  <svg
    width={iconSize}
    height={iconSize}
    viewBox="0 0 24 24"
    fill={blue}
    stroke="none"
    style={{ flexShrink: 0 }}
  >
    {/* Heads */}
    <circle cx="12" cy="7" r="3" />
    <circle cx="5" cy="9" r="2" />
    <circle cx="19" cy="9" r="2" />

    {/* Shared “table”/shoulders */}
    <path d="M2 20c0-3.31 4.03-6 10-6s10 2.69 10 6v1H2v-1z" />
  </svg>
);

const CodeIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
    <polyline points="16 18 22 12 16 6" stroke={blue} strokeWidth={2} strokeLinecap="round" />
    <polyline points="8 6 2 12 8 18" stroke={blue} strokeWidth={2} strokeLinecap="round" />
  </svg>
)
const CloudIcon = () => (
  <svg width={iconSize} height={iconSize} viewBox="-1 -1 26 26" fill="none" style={{ flexShrink: 0 }}>
    <path d="M19 18a4 4 0 0 0-1-7.874 6 6 0 0 0-11-1.106A5 5 0 1 0 5 18h14Z" stroke={blue} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

const FEATURES_EN = [
  { title: 'All-in-one, Unified Platform', icon: <DataIcon />, bullets: ['No need to worry about databases, servers or infra', 'Comes out-of-the-box with powerful, frontend, backend & database servers', '100% Cloud-hosted'] },
  { title: 'No code, maximal control', icon: <BuilderIcon />, bullets: ['Pixel-precise visual drag-and-drop builder', 'Plain-english functionality specs per component', 'Design doubles as living documentation'] },
  { title: 'Enterprise Governance', icon: <ShieldIcon />, bullets: ['Role-based permissions from Apps to database columns', 'Immutable audit log of every key action'] },
  { title: 'AI End-to-end', icon: <CreationIcon />, bullets: ['Design, Build, Refine & Debug with AI', 'Build in minutes, not weeks- at lower costs than ever before', 'AI knows exactly what happened: not just the error'] },
  { title: 'Built for Teams', icon: <CollaborationIcon />, bullets: ['App designs can be shared and edited by teams', 'Teams can be organised into groups with tailored access and permissions'] },
  { title: 'Fully Cloud Platform', icon: <CloudIcon />, bullets: ['All your Apps run on BusinessA\'s scalable cloud infrastructure', '100% browser-based: no installs'] },
  { title: 'Context-Aware AI Debugging', icon: <BugIcon />, bullets: ['AI knows exactly what happened: not just the error', 'Pin-points & patches failing parts only'] },
  { title: 'SDK & Web API', icon: <CodeIcon />, bullets: ['Leverage BusinessA\'s scalable databases & infra by building custom Apps on top of it', "Programmatic CRUD for databases, apps, backend automations & more"] },
]

const FEATURES_ZH = [
  {
    title: '一体化统一平台',
    icon: <DataIcon />,
    bullets: [
      '无需担心数据库、服务器或基础设施',
      '开箱即用的强大前端、后端及数据库服务器',
      '100% 云托管',
    ],
  },
  {
    title: '零代码，极致掌控',
    icon: <BuilderIcon />,
    bullets: [
      '像素级精确的可视化拖拽式构建器',
      '每个组件的功能规范均以简明英文描述',
      '设计即活文档',
    ],
  },
  {
    title: '企业级治理',
    icon: <ShieldIcon />,
    bullets: [
      '从应用到数据库列的基于角色的权限控制',
      '关键操作的不可变审计日志',
    ],
  },
  {
    title: '端到端 AI 赋能',
    icon: <CreationIcon />,
    bullets: [
      '使用 AI 进行设计、构建、优化与调试',
      '数分钟内完成构建，而非数周，成本史无前例地低',
      'AI 深知发生了什么，不止是错误本身',
    ],
  },
  {
    title: '为团队而生',
    icon: <CollaborationIcon />,
    bullets: [
      '应用设计可由团队共享并协作编辑',
      '可将团队组织为分组并配置针对性的访问与权限',
    ],
  },
  {
    title: '全云化平台',
    icon: <CloudIcon />,
    bullets: [
      '所有应用运行在 BusinessA 可扩展的云基础设施上',
      '100% 浏览器使用，无需安装',
    ],
  },
  {
    title: '上下文感知 AI 调试',
    icon: <BugIcon />,
    bullets: [
      'AI 精准了解问题根源，不止于错误提示',
      '精准定位并修复故障部分',
    ],
  },
  {
    title: 'SDK 与 Web API',
    icon: <CodeIcon />,
    bullets: [
      '在 BusinessA 可扩展的数据库与基础设施之上构建自定义应用',
      '通过编程方式对数据库、应用、后台自动化等进行 CRUD 操作',
    ],
  },
];

export const $FEATURES = { en: FEATURES_EN, zh: FEATURES_ZH }